var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLicense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "license",
    transform: "translate(0.01 -0.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4933",
    "data-name": "Path 4933",
    d: "M396.5,59.515v-25a2.5,2.5,0,0,0-2.5-2.5H384v5h7.5v22.5Z",
    transform: "translate(-264.012 -21.999)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4934",
    "data-name": "Path 4934",
    d: "M56.014,240.008v62.5a2.5,2.5,0,0,0,2.5,2.5h99.994a2.5,2.5,0,0,0,2.5-2.5v-17.5h-5v15H61.014v-60Z",
    transform: "translate(-38.517 -164.992)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4935",
    "data-name": "Path 4935",
    d: "M137.045.266c-.078-.035-.152-.055-.233-.083a2.481,2.481,0,0,0-.647-.129.956.956,0,0,0-.155-.038h-77.5a2.5,2.5,0,0,0-2.5,2.5v5h5v-2.5h72.5v20a2.5,2.5,0,0,0,2.5,2.5h20v12.5h5v-15c0-.053-.027-.1-.031-.155a2.429,2.429,0,0,0-.129-.647c-.028-.081-.048-.155-.083-.233a2.481,2.481,0,0,0-.5-.733l-22.5-22.5A2.51,2.51,0,0,0,137.045.266Zm15.429,22.25H138.509V8.551Z",
    transform: "translate(-38.517)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4936",
    "data-name": "Path 4936",
    d: "M184.01,330.505v20a2.5,2.5,0,0,0,2.5,2.5h32.5v-5h-30V333h12.5v-5h-15A2.5,2.5,0,0,0,184.01,330.505Z",
    transform: "translate(-126.515 -225.489)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4937",
    "data-name": "Path 4937",
    d: "M216.009,360h15v5h-15Z",
    transform: "translate(-148.515 -247.488)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4938",
    "data-name": "Path 4938",
    d: "M198.507,136.011a17.522,17.522,0,0,0-17.5,17.5v.25l-12.75,13.46-7.982-7.982a2.5,2.5,0,0,0-3.535,0l-22.5,22.5a2.5,2.5,0,0,0,0,3.535l35,35a2.5,2.5,0,0,0,3.535,0l7.5-7.5,13.232-13.228v38.965H96.012v5h99.995a2.5,2.5,0,0,0,2.5-2.5v-60h-5v11.465l-8.714-8.715,13.464-12.75h.25a17.5,17.5,0,0,0,0-35Zm-27.5,78.965-31.463-31.465,3.965-3.965,31.463,31.465Zm18.964-18.965-11.464,11.465-31.463-31.465,11.464-11.465,6.31,6.31-5.625,5.935a2.5,2.5,0,0,0,.048,3.5l12.5,12.5a2.5,2.5,0,0,0,3.485.048l5.937-5.625Zm8.535-30h-1.25a2.5,2.5,0,0,0-1.72.685l-21.981,20.816-9.047-9.048,20.824-21.982a2.5,2.5,0,0,0,.675-1.72v-1.25a12.5,12.5,0,1,1,12.5,12.5Z",
    transform: "translate(-66.016 -93.495)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4939",
    "data-name": "Path 4939",
    d: "M152.011,232.008h25v5h-25Z",
    transform: "translate(-104.516 -159.492)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4940",
    "data-name": "Path 4940",
    d: "M104.012,264.007h30v5h-30Z",
    transform: "translate(-71.516 -181.491)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4941",
    "data-name": "Path 4941",
    d: "M176.01,200.009h30v5h-30Z",
    transform: "translate(-121.015 -137.493)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4942",
    "data-name": "Path 4942",
    d: "M104.012,296.006h15v5h-15Z",
    transform: "translate(-71.516 -203.49)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4943",
    "data-name": "Path 4943",
    d: "M104.012,328.005h20v5h-20Z",
    transform: "translate(-71.516 -225.489)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4944",
    "data-name": "Path 4944",
    d: "M104.012,360h20v5h-20Z",
    transform: "translate(-71.516 -247.488)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4945",
    "data-name": "Path 4945",
    d: "M104.012,392h20v5h-20Z",
    transform: "translate(-71.516 -269.487)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4946",
    "data-name": "Path 4946",
    d: "M104.012,232.008h10v5h-10Z",
    transform: "translate(-71.516 -159.492)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4947",
    "data-name": "Path 4947",
    d: "M168.01,296.006h10v5h-10Z",
    transform: "translate(-115.515 -203.49)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4948",
    "data-name": "Path 4948",
    d: "M200.009,160.01h25v5h-25Z",
    transform: "translate(-137.515 -109.994)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4949",
    "data-name": "Path 4949",
    d: "M30,92.005a30,30,0,0,0,29.946-28.95,6.608,6.608,0,0,0,4.847,1.515,6.779,6.779,0,0,0,10.409,0,6.781,6.781,0,0,0,7.359-7.36,6.78,6.78,0,0,0,0-10.41A6.781,6.781,0,0,0,75.2,39.44a6.779,6.779,0,0,0-10.409,0A6.781,6.781,0,0,0,57.43,46.8a6.486,6.486,0,0,0-1,1.03A30,30,0,1,0,30,92.005Zm31.163-41.65a2.5,2.5,0,0,0,1.421-3.426,1.75,1.75,0,0,1,2.338-2.338,2.5,2.5,0,0,0,3.426-1.421,1.75,1.75,0,0,1,3.3,0,2.5,2.5,0,0,0,3.428,1.421,1.749,1.749,0,0,1,2.336,2.338,2.5,2.5,0,0,0,1.421,3.426,1.751,1.751,0,0,1,0,3.3,2.5,2.5,0,0,0-1.421,3.428,1.682,1.682,0,0,1-.344,2,1.7,1.7,0,0,1-2,.346,2.5,2.5,0,0,0-3.426,1.419,1.75,1.75,0,0,1-3.3,0,2.494,2.494,0,0,0-1.4-1.472,2.544,2.544,0,0,0-.957-.191,2.452,2.452,0,0,0-1.071.25A1.749,1.749,0,0,1,62.572,57.1a2.5,2.5,0,0,0-1.421-3.428,1.75,1.75,0,0,1,0-3.3ZM30,37.005A25,25,0,1,1,5,62,25,25,0,0,1,30,37.005Z",
    transform: "translate(0 -21.989)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    d: "M41.858,110.892a2.5,2.5,0,0,0,3.535,0l25-25-3.535-3.535L43.625,105.589l-5.732-5.732-3.535,3.535Z",
    transform: "translate(-23.628 -56.609)",
    fill: "#ff725e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.1089313e4ea36adc1c1c0222884f6686.svg";
export { ForwardRef as ReactComponent };